import classNames from 'classnames';
import React from 'react';
import { QuoteContent, QuoteContentProps } from '../blocks/QuoteContent';
import styles from './TestimonialCard.module.scss';

export interface TestimonialCardProps extends QuoteContentProps {
  className?: string;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  authorAvatarUrl,
  author,
  className,
}) => {
  return (
    <div className={classNames(styles.testimonial_card, className)}>
      <QuoteContent authorAvatarUrl={authorAvatarUrl} author={author} quote={quote} />
    </div>
  );
};
